import React, { useState } from "react";
import { Button } from "./ui/button";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { downloadApiFile } from "../lib/downloadApiFile";
import { extractError } from "../lib/api";

/**
 * Download Excel (or other file) from a backend export endpoint.
 */
export default function BackendExportButton({
  path,
  params = {},
  filename = "export.xlsx",
  label = "Export Excel",
  testId = "backend-export",
}) {
  const [busy, setBusy] = useState(false);

  const handleExport = async () => {
    setBusy(true);
    try {
      await downloadApiFile(path, filename, params);
      toast.success("Download started");
    } catch (err) {
      toast.error(extractError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="h-8 text-xs gap-1"
      disabled={busy}
      onClick={handleExport}
      data-testid={testId}
    >
      <Download className="h-3.5 w-3.5" />
      {busy ? "Exporting…" : label}
    </Button>
  );
}
